/*
 * Description of what this file is for
 *
 * @package  baukasten
 * @author David Hellmann [davidhellmann.com@gmail.com]
 * pageTitle
 */

import * as ScrollMagic from 'scrollmagic'; // Or use scrollmagic-with-ssr to avoid server rendering problems
import { TweenLite, TimelineLite, Linear } from 'gsap'; // Also works with TweenLite and TimelineLite
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';

const pageTitle = {
    cfg:  {
        name: '.js-pageTitle',
        obj: document.querySelector('.js-pageTitle__imageWrapper'),
        trigger: document.querySelector('.js-pageTitle__trigger'),
        pin: document.querySelector('.js-pageTitle__imageBackground'),
        textWrapper: document.querySelector('.js-pageTitle__textWrapper'),
        controller: '',
        timeline: '',
        scene: ''
    },

    initScrollMonitor() {
        ScrollMagicPluginGsap(ScrollMagic, TweenLite, TimelineLite);

        // Init Vars
        const trigger = document.querySelector('.js-pageTitle__trigger');

        // init controller
        const controller = new ScrollMagic.Controller();

        // init tween
        /* eslint-disable */
        const tween = new TimelineLite().add([
            TweenLite.fromTo(
                '.js-pageTitle__imageBackground',
                2,
                {scale: 0.5, ease: Linear.easeNone},
                {scale: 1, ease: Linear.easeNone},
            ),TweenLite.fromTo(
                '.js-pageTitle__textWrapper',
                0.25,
                {css: {'mix-blend-mode': 'normal'}, ease: Linear.easeNone},
                {css: {'mix-blend-mode': 'screen'}, ease: Linear.easeNone}
            ).delay(1),
            TweenLite.fromTo(
                '.js-pageTitle__textIntro',
                0.25,
                {css: {opacity: '0'}, ease: Linear.easeNone},
                {css: {opacity: '1'}, ease: Linear.easeNone}
            ).delay(1),
        ]);
        /* eslint-enable */

        // build scene
        // eslint-disable-next-line
        const scene = new ScrollMagic.Scene({
            triggerElement: trigger,
            triggerHook: 'onLeave',
            // eslint-disable-next-line
            duration: (window.innerHeight > window.innerWidth) ? window.innerHeight * 1.5 : this.cfg.textWrapper.clientHeight - window.innerHeight, // this.cfg.textWrapper.clientHeight - window.innerHeight, // '200%', // (window.innerHeight > window.innerWidth) ? document.body.clientHeight * 5 : document.body.clientHeight * 2,
            offset: 0
        })
            .setTween(tween)
            .setPin(this.cfg.pin, {spacerClass: 'js-pageTitle__spacer'})
            .addTo(controller);

        /* this.cfg.timeline = anime.timeline({
            targets: this.cfg.obj,
            duration: 100,
            scale: [1, 0.5],
            easing: 'linear',
            direction: 'alternate'
        })
        // eslint-disable-next-line
        .add({opacity: 1})
        // eslint-disable-next-line
        .add({opacity: 0},100);

        // Init Vars
        const trigger = document.getElementById(this.cfg.trigger);

        // init controller
        const controller = new ScrollMagic.Controller();

        // build scene
        // eslint-disable-next-line
        const scene = new ScrollMagic.Scene({
            triggerElement: trigger,
            triggerHook: 'onLeave',
            duration: '200%'
        })
            .setPin(this.cfg.pin)
            .addTo(controller)
            .on('progress', (event) => {
                // eslint-disable-next-line
                this.cfg.timeline.seek(this.cfg.timeline.duration * event.progress);
            });*/
    },

    init() {
        window.addEventListener('load', () => {
            if (document.querySelector(this.cfg.name) && this.cfg.pin) this.initScrollMonitor();
        });
    }
};

export default pageTitle;



// WEBPACK FOOTER //
// ./___src/templates/_molecules/pageTitle/_script.js